import { useTranslation } from "react-i18next";

export default function WhoWeAre() {
  const { t } = useTranslation();

  return (
    <div className="bg-kag-bg text-white">
      {/* HERO */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[60px] pt-12 sm:pt-16 lg:pt-[85px] pb-10 sm:pb-14 lg:pb-[100px] text-center">
          <p className="font-clash text-kag-eyebrow text-[13px] sm:text-[15px] lg:text-[17px] leading-[1.2] uppercase tracking-[0.18em]">
            {t("whoWeAre.eyebrow")}
          </p>
          <h1 className="mt-5 lg:mt-7 font-clash font-medium text-white uppercase text-[56px] sm:text-[80px] md:text-[104px] lg:text-[128px] xl:text-[140px] leading-[0.98] tracking-tight">
            {t("whoWeAre.title")}
          </h1>
          <div className="mx-auto mt-6 lg:mt-9 max-w-[920px] font-clash text-[#b9b9b9] text-[14px] sm:text-[16px] lg:text-[18px] leading-[1.5]">
            <p>{t("whoWeAre.subtitle1")}</p>
            <p>{t("whoWeAre.subtitle2")}</p>
          </div>
        </div>
      </section>

      {/* OUR APPROACH */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-6 md:px-8 lg:px-8">
          <Card>
            <CardHeader>{t("whoWeAre.approachTitle")}</CardHeader>
            <div className="mt-5 lg:mt-7 font-clash font-medium text-[#8e8e8e] text-[14px] sm:text-[15px] lg:text-[17px] leading-[1.55] space-y-3 lg:space-y-4">
              <p>{t("whoWeAre.approachP1")}</p>
              <p>{t("whoWeAre.approachP2")}</p>
              <p>{t("whoWeAre.approachP3")}</p>
            </div>
          </Card>
        </div>
      </section>

      {/* OUR LONG-TERM VIEW */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-6 md:px-8 lg:px-8 mt-5 lg:mt-8">
          <Card>
            <CardHeader>{t("whoWeAre.longTermTitle")}</CardHeader>
            <p className="mt-5 lg:mt-7 font-clash font-medium text-[#8e8e8e] text-[14px] sm:text-[15px] lg:text-[17px] leading-[1.55] max-w-[800px]">
              {t("whoWeAre.longTermBody")}
            </p>
          </Card>
        </div>
      </section>

      {/* WHAT DEFINES US */}
      <section className="bg-kag-bg">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[60px] pt-14 sm:pt-16 lg:pt-[80px] pb-10 lg:pb-[60px] text-center">
          <h2 className="font-clash font-semibold text-white text-[36px] sm:text-[48px] md:text-[60px] lg:text-[68px] leading-[1] tracking-tight">
            {t("whoWeAre.definesTitle")}
          </h2>
        </div>
      </section>

      {/* WHITE BAND with 4 values */}
      <section className="bg-white text-black">
        <div className="mx-auto w-full max-w-page px-5 sm:px-8 md:px-10 lg:px-[90px] py-12 md:py-14 lg:py-[64px]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8">
            <ValueColumn title={t("whoWeAre.value1Title")} body={t("whoWeAre.value1Body")} />
            <ValueColumn title={t("whoWeAre.value2Title")} body={t("whoWeAre.value2Body")} />
            <ValueColumn title={t("whoWeAre.value3Title")} body={t("whoWeAre.value3Body")} />
            <ValueColumn title={t("whoWeAre.value4Title")} body={t("whoWeAre.value4Body")} />
          </div>
        </div>
      </section>

      <div className="h-12 bg-kag-bg" />
    </div>
  );
}

function Card({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="border-y border-l border-white/95 border-solid rounded-[28px] sm:rounded-[44px] lg:rounded-[60px] px-6 sm:px-10 lg:px-[80px] py-8 sm:py-10 lg:py-[48px]"
      style={{ borderRightWidth: 0, borderWidth: 1.006 }}
    >
      {children}
    </div>
  );
}

function CardHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-start gap-3 sm:gap-4 lg:gap-5">
      <span className="block bg-kag-red rounded-full mt-2 sm:mt-3 lg:mt-4 shrink-0 w-[12px] h-[12px] sm:w-[14px] sm:h-[14px] lg:w-[18px] lg:h-[18px]" />
      <h2 className="font-clash font-semibold text-white text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] leading-[1] tracking-tight">
        {children}
      </h2>
    </div>
  );
}

function ValueColumn({ title, body }: { title: string; body: string }) {
  return (
    <div>
      <div className="flex items-center gap-3">
        <span className="block bg-kag-red rounded-full w-[10px] h-[10px] lg:w-[14px] lg:h-[14px] shrink-0" />
        <h3 className="font-clash font-semibold text-[#010f1f] text-[24px] sm:text-[26px] lg:text-[32px] leading-[1] tracking-tight">
          {title}
        </h3>
      </div>
      <p className="mt-3 font-clash font-medium text-[#8e8e8e] text-[13px] lg:text-[14px] leading-[1.5] max-w-[240px]">
        {body}
      </p>
    </div>
  );
}
